import React from 'react';
import { Container, Row, Button } from 'react-bootstrap';
import { useHistory } from "react-router-dom";

function ErrorPage(){
    const history = useHistory()

    function handleBackToHome(){
        history.push('/')
    }

    return (
        <>
            <Container className="mt-5">
                <Row className="justify-content-center d-block">
                    <h1>Uppppssss... Failed to load page!</h1>
                    <Button onClick={ handleBackToHome } size="sm" variant="info">Back to Home</Button>
                </Row>
            </Container>
        </>
    )
}

export default ErrorPage